<template>
    <nav class="navbar navbar-expand-lg navbar-custom" data-bs-theme="dark">
      <div class="container-fluid">
        <a class="navbar-brand d-flex align-items-center" href="/">
            <img v-if="auth.tenant?.logo" :src="auth.tenant.logo" alt="Logo Tenant" height="30" class="d-inline-block align-text-top me-2">
            <img v-else src="@/assets/logo-primary.png" alt="Logo" height="30" class="d-inline-block align-text-top me-2">
            <span class="ms-2 fw-bold text-white d-none d-sm-inline">{{ auth.tenant?.name || 'Painel' }}</span>
        </a>

        <button 
          class="navbar-toggler" 
          type="button" 
          @click="toggleOffcanvas"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
      </div>
    </nav>
</template>

<script>
import { useAuth } from '@/services/auth.js';

export default {
    name: 'Navbar',
    emits: ['toggleOffcanvas'],
    setup() {
        const auth = useAuth();
        return { auth };
    },
    methods: {
        toggleOffcanvas() {
            this.$emit('controlaSidebar', "toggle");
        },
    }
}
</script>


<style scoped>
.navbar-custom {
    background-color: var(--lc3-navbar-primary); /* Cor de fundo escura */
}

@media print {
  .navbar-brand {
    display: none;
  }
}

</style>
